export default __webpack_public_path__ + "static/media/26.0dc4d2e7.png";